// NaN 평가 함수 (it:any):boolean
export const isAbsoluteNaN = function (it) {
  // eslint-disable-next-line no-self-compare
  return it !== it && typeof it === 'number';
};
// null이나 undefined를 확인하기 위한 함수
export const isNone = function (data) {
  return isAbsoluteNaN(data) || data === undefined || data === null;
};
// 순수 Array를 확인하기 위한 함수
export const isArray = function (data) {
  return Array.isArray(data) || data instanceof Array;
};
// array이면 그대로 리턴 아니면 Array로 변경하여 리턴함
export const asArray = function (data, defaultArray) {
  if (isArray(data)) {
    return data;
  }
  if (isNone(data)) {
    return isArray(defaultArray) ? [...defaultArray] : isNone(defaultArray) ? [] : [defaultArray];
  }
  if (typeof data === 'object' && typeof data.toArray === 'function') {
    return data.toArray();
  }
  return [data];
};
// 순수 Object를 확인하기 위한 함수
export const isPlainObject = function (data) {
  return typeof data === 'object' && Boolean(data) && data.constructor === Object;
};
export const isEmpty = function (data) {
  if (isNone(data)) return true;
  if (isArray(data) || typeof data === 'string') return data.length === 0;
  if (isPlainObject(data)) return Object.keys(data).length === 0;
  if (typeof data === 'string') return data.trim().length === 0
  if (data === Number.NEGATIVE_INFINITY) return true
  return false;
};
export const isPresent = function (data) {
  return !isEmpty(data);
};
// Infinity number 평가 함수 (it:any):boolean
export const isInfinity = function (it) {
  return it === Number.POSITIVE_INFINITY || it === Number.NEGATIVE_INFINITY;
};
// 순수 숫자 평가 함수 (it:any):boolean
export const isNumber = function (it) {
  return typeof it === 'number' && !isInfinity(it) && !isAbsoluteNaN(it);
};
// 숫자 혹은 숫자 문자
export const likeNumber = function (it) {
  if (isNumber(it))
    return true;
  if (typeof it === 'string')
    return String(parseFloat(it)) === String(it);
  return false;
};
// 숫자나 글자인지 평가하는 함수
export const isText = function (it) {
  return typeof it === 'string' || isNumber(it);
};
// 클래스 인스턴스나 Object를 확인하기 위한 함수
export const isObject = function (it) {
  return it !== null && typeof it === 'object';
};
// 클래스 인스턴스나 Object를 확인하기 위한 함수
export const isInstance = function (it) {
  return isObject(it) && !isPlainObject(it);
};
// 새로운 array에 담아 리턴합니다.
export const toArray = function (data) {
  return asArray(data).slice(0);
};
export const isJSONContent = function (jsonContent) {
  if (typeof jsonContent !== 'string') {
    return false;
  }
  try {
    JSON.parse(jsonContent);
    return true;
  }
  catch (error) {
    return false;
  }
};

// set, get 의 베이스 함수
export const browse = (obj, path = []) => {
  const pathString = Array.isArray(path) ? path.join('.') : path;
  const keys = String.prototype.split.call(pathString, /[,[\].]+?/).filter(Boolean);
  const result = [];
  keys.reduce((parent, key, depth) => {
    if (parent && typeof parent === 'object') {
      const value = parent[key];
      result.push({ parent, key, depth, value });
      return value;
    }
    else {
      result.push({ parent, key, depth, value: undefined });
      return undefined;
    }
  }, obj);
  return result;
};
// lodash.set 과 같음
export const set = (obj, path, setValue) => {
  const [result] = browse(obj, path).reverse();
  if (!result)
    return;
  const { parent, key } = result;
  if (parent && typeof parent === 'object') {
    parent[key] = setValue;
  }
};

// 얕은 복사를 원하면 Object.assign({}, obj);
// 깊은 복사
export const deepClone = function (obj, limit = 100000) {
  if (limit <= 0) {
    console.error('클론 횟수 제한을 초과했습니다.', obj);
    throw new Error('클론 횟수 제한을 초과했습니다.');
  }

  if (!isObject(obj)) return obj;

  if (Array.isArray(obj)) {
    return obj.map(item => deepClone(item, limit - 1));
  }

  const clonedObj = {};
  Object.keys(obj).forEach(key => {
    clonedObj[key] = deepClone(obj[key], limit - 1);
  });

  return clonedObj;
};


// lodash.get 과 같음
export const get = (obj, path) => {
  const [result] = browse(obj, path).reverse();
  return result ? result.value : undefined;
};
// array의 아이템을 찾고 안의 값을 표시합니다. find, get 이 자주있는 패턴인데 코드가 리더블하지 않아 따로 작성됨
export const findGet = function (data, findFn, getPath) {
  return get(asArray(data).find(findFn), getPath);
};
// 대상 array에 직접 index에 해당하는 값을 삭제합니다.
export const removeIndex = function (data, index) {
  const asData = asArray(data);
  const valueIndexes = asArray(index).filter(indexValue => typeof indexValue === 'number');
  valueIndexes.forEach((removeIndex, offset) => {
    asData.splice(removeIndex - offset, 1);
  });
  return asData;
};

// doit: do expression과 유사하게 동작하면서, 파라미터(it)를 넘기는 기능이 포함된 함수입니다.
// 사용법:
// doit(5, x => x * 2) // 10
// doit(5, x => { throw new Error('fail') }, (e, it) => it) // 5
export const doit = (it, fn = (a) => (a), catchFn) => {
  if (typeof fn === 'function') {
    if (typeof catchFn === 'function') {
      try {
        return fn(it);
      } catch (e) {
        return catchFn(e, it);
      }
    } else {
      return fn(it);
    }
  }
  return undefined;
};
// begin: rails의 begin과 유사한 구현체로, 예외 처리를 포함하여 함수(fn)를 실행합니다.
// 사용법 예시:
// begin(() => { throw new Error('fail') }, e => 'error') // 'error'
// begin(() => 1 + 1) // 2
export const begin = (fn, catchFn) => {
  if (typeof fn === 'function') {
    if (typeof catchFn === 'function') {
      try {
        return fn();
      } catch (e) {
        return catchFn(e);
      }
    } else {
      return fn();
    }
  }
  return undefined;
};
// 
export const tapChain = function (tapData) {
  const tap = async (fn) => {
    let fnResult = null
    if (typeof fn === 'function') {
      fnResult = fn(tapData);
    } else {
      console.error("Invalid tapChain argument: fn", fn)
      throw new Error(`tapChain에서 생성된 tab의 argument는 함수여야 합니다. => fn`)
    }
    return Promise.resolve(fnResult).then(() => tapChain(tapData));
  };
  return tap;
};

export const tapRace = function (tapData, ...tapFns) {
  return tapFns.map((fn) => {
    if (typeof fn === 'function') {
      fn(tapData);
    } else {
      throw new Error(`tapRace의 두번째 함수부터 함수여야 합니다. => #{fn}`)
    }
  })
}

export const transactionHelper = function (config, callback) {
  if (typeof config === 'function') {
    config = callback();
  }
  if (typeof config !== 'object' || config === null) {
    throw new Error('transaction() config must be an object');
  }
  let transactionConfig = {
    enter: config.enter,
    exit: config.exit,
    error: config.error
  }
  if (typeof config.props === 'function') {
    transactionConfig.props = config.props();
  } else {
    transactionConfig.props = config.props || {};
  }
  if (typeof transactionConfig.props !== 'object' || transactionConfig.props === null) {
    throw new Error('transaction() config.props must be an object');
  }
  async function transactionMain() {
    if (transactionConfig.enter) {
      if (typeof transactionConfig.enter !== 'function') {
        throw new Error('transaction() config.enter must be a function');
      }
      await transactionConfig.enter(transactionConfig.props);
    }
    const result = await callback(transactionConfig.props)
    if (transactionConfig.exit) {
      if (typeof transactionConfig.exit !== 'function') {
        throw new Error('transaction() config.exit must be a function');
      }
      await transactionConfig?.exit(transactionConfig.props, result)
    }
    return result
  }

  try {
    return {
      promise: transactionMain(),
    }

  } catch (error) {
    if (typeof transactionConfig.error === 'function') {
      transactionConfig.error(error, config.props);
    } else {
      throw error;
    }
  }
}

export const recall = function (data) {
  return a => a?.(data) || a
}

// 주요 목적은 프록시를 파싱하기 위해 만듬
export const reflect = function (data, gets = null) {
  const reflected = begin(() => {
    if (isInstance(data) && typeof data.toJSON === "function") {
      return data.toJSON();
    }
    if (isNone(data)) {
      return {}
    }
    if (typeof data === 'object') {
      return JSON.parse(JSON.stringify(data))
    }
    return data
  })
  if (gets !== null) {
    return get(reflected, gets)
  } else {
    return reflected
  }
};

// 대상 array에 직접 값을 넣습니다. array가 아니면 array로 자동 캐스팅 됩니다. Set 처럼 동작합니다.
export const addValue = function (data, value) {
  const asData = asArray(data);
  !asData.includes(value) && asData.push(value);
  return asData;
};
// 대상 array에 직접 삭제합니다. array가 아니면 array로 자동 캐스팅 됩니다.
export const removeValue = function (data, value) {
  const asData = asArray(data);
  const valueIndexes = [];
  asData.forEach(typeof value === 'function'
    ? (asValue, index) => value(asValue, index) === true && valueIndexes.push(index)
    : (asValue, index) => asValue === value && valueIndexes.push(index));
  return removeIndex(asData, valueIndexes);
};
// 배열에 index 에 해당하는 위치를 제거하고 새배열로 반환합니다.
export const removedIndex = function (data, index) {
  return removeIndex(toArray(data), index);
};
// 새로운 배열에 새 값을 넣습니다. set처럼 동작합니다.
export const addedData = function (data, value) {
  return addValue(toArray(data), value);
};
// 새로운 배열에 삭제한 값을 포함합니다.
export const removedData = function (data, value) {
  return removeValue(toArray(data), value);
};
// currentValue값을 toggleArgs목록중 존재하면 목록 값중 다음값을 아니면 첫번째 값을 반환함
export const toggleValue = (toggleValues, currentValue, step = 1) => {
  return ((toggleValues = asArray(toggleValues)) &&
    toggleValues[(toggleValues.findIndex(val => val === currentValue) + step) % toggleValues.length]);
};
export const nextValue = (toggleValues, currentValue, step = 1) => toggleValue(toggleValues, currentValue, 1 * step);
export const prevValue = (toggleValues, currentValue, step = 1) => toggleValue(toggleValues, currentValue, -1 * step);
// 숫자의 크기를 제한함 ( numbers:number|Array, max:number, min:number )
// limitNumber(10,5); //5
// limitNumber([10,10],5) // [5, 5]
// limitNumber([0,1,2,3], 2, 1) // [1,1,2,2]
export const limitNumber = (function () {
  const limitOf = function (number, max, min) {
    if (typeof number == 'number') {
      if (isNaN(number) || number === Infinity) {
        return min;
      }
      if (number < min) {
        return min;
      }
      if (number > max) {
        return max;
      }
    }
    return number;
  };
  const limitNumber = function (...args) {
    let [numbers, max, min] = args;
    if (args.length === 2 && Array.isArray(max)) {
      const polymophMinMaxParameter = max;
      min = polymophMinMaxParameter[0];
      max = polymophMinMaxParameter[1];
    }
    if (typeof max !== 'number') {
      max = Number.POSITIVE_INFINITY;
    }
    if (typeof min !== 'number') {
      if (min === null || isNaN(min)) {
        min = Number.NEGATIVE_INFINITY;
      }
      else {
        min = 0;
      }
    }
    if (Array.isArray(numbers)) {
      for (var d = numbers, i = 0, l = d.length; i < l; i++) {
        d[i] = limitOf(d[i], max, min);
      }
      return numbers;
    }
    else {
      return limitOf(numbers, max, min);
    }
  };
  return limitNumber;
})();
// Object를 Array.map과 같이 iteration 시킴 (object:Object, fn:Function):Object
export const hashMap = function (object, fn) {
  if (typeof object === 'object' && !isArray(object))
    for (var k in object)
      object[k] = fn(object[k], k);
  else
    return fn(object, void 0);
  return object;
};
// v값을 domain값에 준하여, range값으로 변경함 시킴 d3의 domain range와 같은 개념임
// (domain:number|Array, range:number|Array, vs:number|Array, nice:boolean, limit:number|Array):number|Array;
export const domainRangeValue = function (domain, range, vs, nice, limit) {
  return hashMap(vs, function (v, sel) {
    const $range = sel ? range[sel] : range;
    const $domain = sel ? domain[sel] : domain;
    if (!$range || !$domain) {
      return v;
    }
    const dSize = $domain[1] - $domain[0];
    const sSize = $range[1] - $range[0];
    const dRatePre = v - $domain[0];
    const dRate = dRatePre === 0 ? 0 : dRatePre / dSize;
    const calc = $range[0] + sSize * dRate;
    const nicedValue = nice ? Math.floor(calc) : calc;
    return limit
      ? $range[1] > $range[0]
        ? limitNumber(nicedValue, $range[1], $range[0])
        : limitNumber(nicedValue, $range[0], $range[1])
      : nicedValue;
  });
};
export function isEmptyObject(object) {
  if (object === null)
    return true;
  if (object === undefined)
    return true;
  if (object.length > 0)
    return false;
  if (object.length === 0)
    return true;
  if (typeof object !== 'object')
    return true;
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key))
      return false;
  }
  return true;
}
/**
 * 두 배열의 교집합을 사용자 정의 비교 함수로 찾습니다.
 * @param {Array} aArray - 첫 번째 입력 배열
 * @param {Array} bArray - 두 번째 입력 배열
 * @param {Function} [comparator=(a,b)=>a===b] - 요소의 동등성을 판단하는 선택적 비교 함수
 * @returns {Array} 두 입력 배열 모두에 존재하는 요소를 담은 배열
 */
export function intersectArrays(aArray, bArray, comparator = (a, b) => a === b) {
  const intersection = [];
  for (let i = 0; i < aArray.length; i++) {
    for (let j = 0; j < bArray.length; j++) {
      if (comparator(aArray[i], bArray[j])) {
        intersection.push(aArray[i]);
      }
    }
  }
  return intersection
}

/**
 * 배열 또는 이터러블의 "내용(중복 포함, 순서 무시)"이 동등할 때 true를 반환합니다.
 * (예: [1,2,2], [2,1,2] -> true. [1,2,2], [2,2] -> false)
 */
export function equalContents(aData, bData, comparator) {
  const a = asArray(aData)
  const b = asArray(bData)
  if (a.length !== b.length) return false
  const aSample = [...a].sort()
  const bSample = [...b].sort()
  const defaultComparator = (a, b) => a === b
  if (typeof comparator === "function") {
    comparator = (a, b) => comparator(a, b, defaultComparator)
  } else {
    comparator = defaultComparator
  }
  for (let i = 0; i < aSample.length; i++) {
    const index = bSample.findIndex(v => comparator(v, aSample[i]))
    if (index === -1) return false
    bSample.splice(index, 1)
  }
  return true
}

export function spliced(array, start, deleteCount, ...items) {
  return [...array.slice(0, start), ...items, ...array.slice(start + deleteCount)];
}
export const turn = function (i, limit, ts, resultHook) {
  if (i < 0) {
    let abs = Math.abs(i / ts);
    i = limit - (abs > limit ? abs % limit : abs);
  }
  ts = typeof ts === 'number' ? ts : 1;
  const fixIndex = Math.floor(i / ts);
  const result = limit > fixIndex ? fixIndex : fixIndex % limit;
  return typeof resultHook === 'function' ? resultHook(result, i, limit, ts) : result;
};
// UUID v4 generator in JavaScript (RFC4122 compliant)
export const generateUUID = (pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx') => pattern.replace(/[xy]/g, c => {
  const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 3) | 8; // eslint-disable-line no-mixed-operators
  return v.toString(16);
});

export const laneWatch = function () {
  let listeners = [];
  let params = [];
  function emitValue(...newParams) {
    if (newParams.length !== params.length ||
      newParams.some((newValue, index) => {
        return newValue !== params[index];
      })) {
      params = newParams;
      listeners.forEach(fn => {
        fn(...newParams);
      });
    }
  }
  function watch(fn) {
    listeners.push(fn);
    return function unwatch() {
      listeners = listeners.filter(listener => listener !== fn);
    };
  }
  return Object.defineProperties({}, {
    listeners: {
      enumerable: true,
      get: () => [...listeners],
    },
    params: {
      enumerable: true,
      get: () => [...params],
    },
    emit: {
      enumerable: false,
      value: emitValue,
    },
    watch: {
      enumerable: false,
      value: watch,
    },
  });
};
export const splitCaseString = (s, c = undefined) => {
  if (typeof c === 'string')
    return s.split(c);
  if (typeof s !== 'string')
    return String(s);
  s = s.replace(/^#/, ''); /*kebab*/
  var k = s.split('-');
  if (k.length > 1)
    return k; /*snake*/
  var _ = s.split('_');
  if (_.length > 1)
    return _; /*Cap*/
  return s
    .replace(/[A-Z][a-z]/g, function (s) {
      return '%@' + s;
    })
    .replace(/^%@/, '')
    .split('%@');
};
export const toPascalCase = s => {
  var words = splitCaseString(s);
  for (var i = 0, l = words.length; i < l; i++)
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
  return words.join('');
};
export const toCamelCase = s => {
  var words = splitCaseString(s);
  for (var i = 1, l = words.length; i < l; i++)
    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
  words[0] = words[0].toLowerCase();
  return words.join('');
};
export const toSnakeCase = s => {
  var words = splitCaseString(s);
  for (var i = 0, l = words.length; i < l; i++)
    words[i] = words[i].toLowerCase();
  return words.join('_');
};
export const toKebabCase = s => {
  var words = splitCaseString(s);
  for (var i = 0, l = words.length; i < l; i++)
    words[i] = words[i].toLowerCase();
  return words.join('-');
};
export const asCameCaseKeys = plainObject => {
  const result = {};
  for (const key in plainObject) result[toCamelCase(key)] = plainObject[key];
  return result;
}
export const asSnakeCaseKeys = plainObject => {
  const result = {};
  for (const key in plainObject) result[toSnakeCase(key)] = plainObject[key];
  return result;
}
export const asKebobCaseKeys = plainObject => {
  const result = {};
  for (const key in plainObject) result[toKebabCase(key)] = plainObject[key];
  return result;
}
export const timescaleExp = function (exp) {
  var scale = 0;
  if (typeof exp === 'number') {
    return exp;
  }
  if (typeof exp === 'string') {
    //
    exp = exp.replace(/\d+(Y|years|year)/, function (t) {
      t.replace(/\d+/, function (d) {
        scale += Number(d) * 31536000000;
        return '';
      });
      return '';
    });
    exp = exp.replace(/\d+(M|months|month)/, function (t) {
      t.replace(/\d+/, function (d) {
        scale += Number(d) * 2678400000;
        return '';
      });
      return '';
    });
    exp = exp.replace(/\d+(D|day|dates|date)/, function (t) {
      t.replace(/\d+/, function (d) {
        scale += Number(d) * 86400000;
        return '';
      });
      return '';
    });
    exp = exp.replace(/\d+(h|hours|hour)/, function (t) {
      t.replace(/\d+/, function (d) {
        scale += Number(d) * 3600000;
        return '';
      });
      return '';
    });
    exp = exp.replace(/\d+(ms|milliseconds|millisecond)/, function (t) {
      t.replace(/\d+/, function (d) {
        scale += Number(d) * 1;
        return '';
      });
      return '';
    });
    exp = exp.replace(/\d+(m|minutes|minute)/, function (t) {
      t.replace(/\d+/, function (d) {
        scale += Number(d) * 60000;
        return '';
      });
      return '';
    });
    exp = exp.replace(/\d+(s|seconds|second)/, function (t) {
      t.replace(/\d+/, function (d) {
        scale += Number(d) * 1000;
        return '';
      });
      return '';
    });
  }
  return scale;
};
